import { extractParamsFromBase64, getHashParam } from '../helpers/query/query';
import { language } from '../modules/language/language';

export async function bootstrap() {
  try {
    let lang = language('en');
    const hashParam = getHashParam();

    if (!hashParam) throw new Error('Hash parameter is empty');

    const params = extractParamsFromBase64(hashParam);

    if (!params) throw new Error('No values found in hash parameter');

    const extFairId = params.mid ?? '';
    const quotelineId = params.qlid ?? '';
    const aQuotelineId = params.aqlid ?? '';
    const showHall = params.hall ?? '';
    const showOnlyNischenstaende = params.nischenstaende ?? false;

    if (params.lang) {
      lang = language(params.lang);
    }

    if (!extFairId || extFairId.trim() === '') throw new Error('No external fair id found');

    if (
      (!quotelineId || quotelineId.trim() === '')
      && (!showHall || showHall.trim() === '')
    ) {
      throw new Error('No quoteline id or hall found');
    }

    return { extFairId, quotelineId, aQuotelineId, showHall, showOnlyNischenstaende, lang };
  } catch (e) {
    console.error('Could not complete boostrap:', e);
  }
}